<div class="d-flex flex-column">
  <!-- Header Card -->
  <div class="mb-3" style="background-color: #FFFFFF; padding-bottom: 8px;">
    <div
      id="title-itinerary"
      class="d-flex justify-content-center align-items-center py-3 mb-3"
      style="border-top-left-radius: 8px; border-top-right-radius: 8px;"
      [ngStyle]="getHeaderStyle()"
    >
      <p
        class="mb-0 font-weight-bold"
        style="font-family: &quot;Poppins&quot;, serif; font-size: 32px; font-weight: 700;"
        [ngStyle]="getTitleColorStyle()"
      >
        File
      </p>
    </div>

    <!-- Hardcoded Header Buttons -->
    <div class="row py-2 px-4">
      <div class="col-6 px-1">
        <button (click)="_redirectToHome()" class="btn btn-cancel w-100">Regresar</button>
      </div>
      <div class="col-6 px-1">
        <button (click)="_redirectToSummary()" class="btn btn-confirm w-100">Continuar</button>
      </div>
    </div>
  </div>

  <!-- ========== INITIAL LOAD SKELETON ========== -->
  <div *ngIf="isLoading" style="border-radius: 5px; padding: 0 4px;">
    <!-- 1 City header skeleton -->
    <div class="skeleton-city-header mb-3">
      <div class="skeleton-shimmer" style="width: 45%; height: 20px; border-radius: 4px; margin-bottom: 10px;"></div>
      <div class="skeleton-shimmer" style="width: 65%; height: 14px; border-radius: 4px;"></div>
    </div>
    <!-- 3 Item skeletons -->
    <div *ngFor="let s of SKELETON_ITEMS" class="skeleton-item-card mb-2">
      <div class="d-flex align-items-start" style="gap: 12px; padding: 20px 16px;">
        <div class="flex-grow-1 d-flex flex-column" style="gap: 8px;">
          <div class="skeleton-shimmer" style="width: 40px; height: 40px; border-radius: 8px; flex-shrink: 0;"></div>
          <div class="skeleton-shimmer" style="width: 45%; height: 12px; border-radius: 4px;"></div>
          <div class="skeleton-shimmer" style="width: 70%; height: 16px; border-radius: 4px;"></div>
          <div class="skeleton-shimmer" style="width: 30%; height: 12px; border-radius: 4px;"></div>
        </div>
        <div class="d-flex align-items-center" style="gap: 8px;">
          <div class="skeleton-shimmer" style="width: 80px; height: 16px; border-radius: 4px;"></div>
          <div class="skeleton-shimmer" style="width: 20px; height: 20px; border-radius: 4px;"></div>
        </div>
      </div>

      <hr />

      <div class="d-flex flex-column" style="gap: 8px; padding: 20px 16px;">
        <div class="skeleton-shimmer" style="width: 80px; height: 16px; border-radius: 4px;"></div>
        <div class="skeleton-shimmer" style="width: 120px; height: 16px; border-radius: 4px;"></div>
        <div class="skeleton-shimmer" style="width: 80px; height: 16px; border-radius: 4px;"></div>
        <div class="skeleton-shimmer" style="width: 40px; height: 16px; border-radius: 4px;"></div>
      </div>

      <hr />

      <div class="d-flex align-items-center" style="gap: 8px; padding: 20px 16px;">
        <div class="skeleton-shimmer" style="width: 40px; height: 40px; border-radius: 8px; flex-shrink: 0;"></div>
        <div class="skeleton-shimmer" style="width: 100px; height: 16px; border-radius: 4px;"></div>
      </div>
    </div>
  </div>

  <!-- ========== REAL CONTENT ========== -->
  <div *ngIf="!isLoading && cities && cities.length > 0" style="border-radius: 5px">
    <div *ngFor="let cityGroup of cities; let i = index" class="m-0 content-sidebar">
      <div *ngFor="let dateGroup of cityGroup.items" class="title-cityName text-uppercase" style="width: 100%">
        <div class="d-flex flex-column p-4 content-cityName mb-3">
          <h2 class="mb-1 title-cityName" style="text-transform: capitalize; line-height: 1" [ngStyle]="getTitleColorStyle()">
            {{ cityGroup.city }}
          </h2>

          <p class="title-date m-0" style="text-transform: capitalize; margin: auto 0" [ngStyle]="getTitleColorStyle()">
            {{ dateGroup.arrivalDate | date: "dd - MMM" }}
            <span style="text-transform: lowercase">a</span>
            {{ dateGroup.departureDate | date: "dd - MMM" }}
          </p>
        </div>

        <!-- Items -->
        <div
          *ngFor="let item of dateGroup.items; let idx = index; let last = last"
          class="item mb-2 pb-5"
        >
          <!-- Per-item skeleton (for add/remove) -->
          <ng-container *ngIf="isItemLoading(item); else realItem">
            <div class="d-flex align-items-start justify-content-between" style="gap: 12px; padding: 20px 16px;">
              <div class="flex-grow-1 d-flex flex-column" style="gap: 8px; min-width: 140px;">
                <div class="skeleton-shimmer" style="width: 40px; height: 40px; border-radius: 8px; flex-shrink: 0;"></div>
                <div class="skeleton-shimmer" style="width: 100%; height: 12px; border-radius: 4px;"></div>
                <div class="skeleton-shimmer" style="width: 80%; height: 16px; border-radius: 4px;"></div>
                <div class="skeleton-shimmer" style="width: 50%; height: 12px; border-radius: 4px;"></div>
              </div>
              <div class="d-flex align-items-center" style="gap: 8px;">
                <div class="skeleton-shimmer" style="width: 80px; height: 16px; border-radius: 4px;"></div>
                <div class="skeleton-shimmer" style="width: 20px; height: 20px; border-radius: 4px;"></div>
              </div>
            </div>

            <hr />

            <div class="d-flex flex-column" style="gap: 8px; padding: 20px 16px;">
              <div class="skeleton-shimmer" style="width: 80px; height: 16px; border-radius: 4px;"></div>
              <div class="skeleton-shimmer" style="width: 120px; height: 16px; border-radius: 4px;"></div>
              <div class="skeleton-shimmer" style="width: 80px; height: 16px; border-radius: 4px;"></div>
              <div class="skeleton-shimmer" style="width: 40px; height: 16px; border-radius: 4px;"></div>
            </div>

            <hr />

            <div class="d-flex align-items-center" style="gap: 8px; padding: 20px 16px;">
              <div class="skeleton-shimmer" style="width: 40px; height: 40px; border-radius: 8px; flex-shrink: 0;"></div>
              <div class="skeleton-shimmer" style="width: 100px; height: 16px; border-radius: 4px;"></div>
            </div>
          </ng-container>

          <ng-template #realItem>
            <!-- Status and Remove -->
            <div class="d-flex justify-content-end align-items-start w-100" style="position: absolute; top: 0;">
              <div class="d-flex flex-column justify-content-between mr-4" style="margin-top: 12px;">
                <ng-container *ngIf="item.statusIds && item.statusIds.length > 0">
                  <div class="d-flex align-items-center" style="gap: 5px;">
                    <ng-container *ngFor="let status of item.statusIds">
                      <span *ngIf="item.statusIds.length === 1" [class]="'status status-sidebar ' + getStatusClass(status.statusId)">
                        {{ status.statusName }}
                      </span>

                      <div *ngIf="item.statusIds.length > 1" [class]="'status status-sidebar status-rounded ' + getStatusClass(status.statusId)">
                        {{ status.statusName.charAt(0) }}

                        <span class="status-tooltip">{{ status.statusName }}</span>
                      </div>
                    </ng-container>
                  </div>
                </ng-container>

                <ng-container *ngIf="!item.statusIds || item.statusIds.length === 0">
                  <span [class]="'status status-sidebar ' + getStatusClass(item.statusId)">
                    {{ item.status }}
                  </span>
                </ng-container>
              </div>

              <ng-container *ngIf="canShowDeleteButton(item)">
                <button
                  class="d-flex align-items-center justify-content-center py-1 px-1"
                  style="border-bottom-left-radius: 10px; border: none; background-color: #facad3; width: 35px; height: 35px;"
                >
                  <!-- Cancel icon for "Reservado" (statusId 2) items: matches the
                       icon used in the itinerary-summary view. Same handler
                       onRemoveItem(), the .ts branches internally. -->
                  <div
                    *ngIf="isItemReserved(item)"
                    class="item-button"
                    (click)="getItemCategoryName(item) === 'TRANSPORTS' ? onRemoveTransfer({ item: item, transfer: item }) : onRemoveItem(item)"
                    title="cancel"
                  >
                    <img
                      src="../../../../assets/icons/itinerary-detail/04-01.svg"
                      alt="cancel"
                      style="
                        width: 20px;
                        filter: invert(16%) sepia(99%) saturate(7493%) hue-rotate(1deg) brightness(95%) contrast(119%);
                      "
                    />
                  </div>

                  <!-- Default trash icon for items in "Cotización" (statusId 1) -->
                  <div
                    *ngIf="!isItemReserved(item)"
                    class="item-button"
                    (click)="getItemCategoryName(item) === 'TRANSPORTS' ? onRemoveTransfer({ item: item, transfer: item }) : onRemoveItem(item)"
                    title="delete"
                  >
                    <svg version="1.1" id="Layer_2_00000146472910104976704670000005604375476625682068_"
                      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512"
                      style="fill: #ff3f63; width: 20px;" xml:space="preserve">
                      <path d="M422.1,82H388V53c0-29.3-23.7-53-53-53H177c-29.3,0-53,23.7-53,53v29H90c-18.8,0-34.1,15.3-34.1,34.1v54.6
                        c0,9.4,7.6,17.1,17.1,17.1l0,0h10.3v273c0,28.3,22.9,51.2,51.2,51.2h243.2c28.3,0,51.2-22.9,51.2-51.2V187.7h10.4
                        c9.4,0,17.1-7.1,17.1-17c0,0,0,0,0,0v-54.5C456.2,97.3,440.9,82,422.1,82z M158.1,53c0-10.4,8.5-18.9,18.9-18.9h158
                        c10.4,0,18.9,8.4,18.9,18.9v29H158.1V53z M89.9,116.1h332.2v37.5H89.9V116.1z M394.7,460.8c0,9.4-7.6,17.1-17.1,17.1H134.4
                        c-9.4,0-17.1-7.6-17.1-17.1V187.7h277.3V460.8z"/>
                      <path d="M170.7,447c9.4,0,17-7.6,17.1-17V235.6c0.2-9.4-7.2-17.2-16.7-17.5s-17.2,7.2-17.5,16.7c0,0.3,0,0.6,0,0.8V430
                        C153.6,439.4,161.3,447,170.7,447z"/>
                      <path d="M256,447c9.4,0,17-7.6,17.1-17V235.6c0-9.4-7.6-17.1-17.1-17.1c-9.4,0-17.1,7.6-17.1,17.1V430C239,439.4,246.6,447,256,447z
                        "/>
                      <path d="M341.3,447c9.4,0,17-7.6,17.1-17V235.6c0.2-9.4-7.2-17.2-16.7-17.5c-9.4-0.2-17.2,7.2-17.5,16.7c0,0.3,0,0.6,0,0.8V430
                        C324.3,439.4,331.9,447,341.3,447z"/>
                    </svg>
                  </div>
                </button>
              </ng-container>
            </div>

            <!-- Item Content - each item type wraps itself in base-item -->
            <div class="px-4 pt-4">
              <ng-container [ngSwitch]="getItemCategoryName(item)">
                <usb-hotel-item
                  *ngSwitchCase="'HOTELS'"
                  [item]="item"
                  [styleSidebar]="styleSidebar"
                  [currencyAgency]="currencyAgency"
                  [currencies]="currencies"
                  [clientsSettingAppBooking]="clientsSettingAppBooking"
                  (openMap)="onOpenHotelMap($event)"
                  (removeRoom)="onRemoveRoom($event)"
                >
                </usb-hotel-item>

                <usb-transport-item
                  *ngSwitchCase="'TRANSPORTS'"
                  [item]="item"
                  [styleSidebar]="styleSidebar"
                  [currencyAgency]="currencyAgency"
                  [currencies]="currencies"
                  [clientsSettingAppBooking]="clientsSettingAppBooking"
                  (removeTransfer)="onRemoveTransfer($event)"
                >
                </usb-transport-item>

                <usb-experience-item
                  *ngSwitchCase="'TOURS'"
                  [item]="item"
                  [styleSidebar]="styleSidebar"
                  [currencyAgency]="currencyAgency"
                  [currencies]="currencies"
                  [clientsSettingAppBooking]="clientsSettingAppBooking"
                >
                </usb-experience-item>

                <usb-ticket-item
                  *ngSwitchCase="'TICKET'"
                  [item]="item"
                  [styleSidebar]="styleSidebar"
                  [currencyAgency]="currencyAgency"
                  [currencies]="currencies"
                  [clientsSettingAppBooking]="clientsSettingAppBooking"
                  (removeTicket)="onRemoveItem($event)"
                >
                </usb-ticket-item>

                <usb-rent-a-car-item
                  *ngSwitchCase="'RENT-A-CAR'"
                  [item]="item"
                  [styleSidebar]="styleSidebar"
                  [currencyAgency]="currencyAgency"
                  [currencies]="currencies"
                  [clientsSettingAppBooking]="clientsSettingAppBooking"
                >
                </usb-rent-a-car-item>

                <usb-insurance-item
                  *ngSwitchCase="'INSURANCE'"
                  [item]="item"
                  [styleSidebar]="styleSidebar"
                  [currencyAgency]="currencyAgency"
                  [currencies]="currencies"
                  [clientsSettingAppBooking]="clientsSettingAppBooking"
                >
                </usb-insurance-item>
              </ng-container>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty State -->
  <div *ngIf="!isLoading && (!cities || cities.length === 0)" class="empty-state text-center">
    <div class="empty-state__icon mb-4">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="9" cy="21" r="1"/>
        <circle cx="20" cy="21" r="1"/>
        <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
      </svg>
    </div>
    <h3 class="empty-state__title mb-2">Tu carrito está vacío</h3>
    <p class="empty-state__subtitle mb-0">¡Explora y agrega servicios para tu próximo viaje!</p>
  </div>
</div>
